@if (budgetLibraryQuery.selectLoading() | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((budgetLibraryQuery.selectLoading() | async) === false) {
  <div class="mb-2 flex items-center">
    <aux-input
      class="mr-4 w-64"
      placeholder="Search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
      [(ngModel)]="nameFilterValue"
    />
    <aux-vendor-dropdown
      [showAllOption]="true"
      [vendors]="vendors"
      [formControl]="selectedVendor"
    />
  </div>
  <div>
    <ag-grid-angular
      style="height: 600px"
      class="ag-theme-alpine budget-library-table w-full tabular-nums"
      [gridOptions]="(gridOptions$ | async)!"
      [rowData]="gridData$ | async"
      [quickFilterText]="nameFilterValue"
      [getRowHeight]="getRowHeight"
      (firstDataRendered)="onDataRendered($event)"
      (gridReady)="onGridReady($event)"
      (columnResized)="autoSize()"
    />
  </div>
}
